<div class="loading-shade" *ngIf="isLoadingResults$ | async">
  <div class="flex col center">
    <div class="flex center alignCenter">
      <mat-spinner [diameter]="30"></mat-spinner>
    </div>
    <em>{{ loaderMessage$ | async }}</em>
  </div>
</div>
